import camelcaseKeys from "camelcase-keys";
import { z } from "zod";

import { authorizedGet } from "../../authorizedRequests";

const SessionReponseSchema = z.object({
  paymentMethod: z.string().nullish(),
  pastCustomerTabIds: z.array(z.number()),
  pastCartIds: z.array(z.number()),
  venueCartIds: z.record(z.string(), z.string()), // venueUuid -> cartUuid
  venueCustomerTabIds: z.record(z.string(), z.string()), // venueUuid -> customerTabUuid
});

export type SessionResponse = z.infer<typeof SessionReponseSchema>;

export const getSession = async (): Promise<SessionResponse> => {
  const response = await authorizedGet({
    url: `/v1/mobile_order_sessions`,
  });
  const {
    venue_cart_ids: venueCartIds,
    venue_customer_tab_ids: venueCustomerTabIds,
    ...body
  } = response.body.session;
  const responseData = camelcaseKeys(body, {
    deep: true,
  });

  return SessionReponseSchema.parse({
    venueCartIds: venueCartIds || {},
    venueCustomerTabIds: venueCustomerTabIds || {},
    ...responseData,
  });
};
